let requestLib = null

export default {
  get: () => requestLib,
  set: (lib) => {
    requestLib = lib
  },
}
